import { render, staticRenderFns } from "./AccidentsCountLineChart.vue?vue&type=template&id=60431479&scoped=true&"
import script from "./AccidentsCountLineChart.vue?vue&type=script&lang=js&"
export * from "./AccidentsCountLineChart.vue?vue&type=script&lang=js&"
import style0 from "./AccidentsCountLineChart.vue?vue&type=style&index=0&id=60431479&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60431479",
  null
  
)

export default component.exports